import { SCheckbox, SText } from '@setvi/shared/components';
import { SetviSwitch } from '@setvi/shared/components/sforms/sformik/formik-switch';
import { BuildingIconV2 } from '@setvi/shared/components/sicons';
import {
  Row,
  IconBox,
  TextContainer,
  Title,
  Container,
  Description,
  CheckboxRow,
  CheckboxLabel
} from './style';

export const QUOTE_PDF_SETTINGS_DIALOG = 'quote-pdf-settings-dialog';

export interface QuoteDisplayData {
  showManufacturerDetails: boolean;
  setAsDefault: boolean;
}

interface QuoteDisplayProps {
  data: QuoteDisplayData;
  onChange: (data: QuoteDisplayData) => void;
}

const QuoteDisplay = ({ data, onChange }: QuoteDisplayProps) => {
  const { showManufacturerDetails, setAsDefault } = data;

  return (
    <Container>
      <SText size="lg" weight="bold">
        Quote Display
      </SText>

      <Row>
        <IconBox>
          <BuildingIconV2 style={{ width: 20, height: 20 }} />
        </IconBox>
        <TextContainer>
          <Title>Show Manufacturer Details</Title>
          <Description>
            Displays Manufacturer name & Manufacturer SKU in the Digital Room.
          </Description>
        </TextContainer>
        <SetviSwitch
          checked={showManufacturerDetails}
          onChange={e =>
            onChange({ ...data, showManufacturerDetails: e.target.checked })
          }
        />
      </Row>

      <CheckboxRow>
        <CheckboxLabel>Set as default</CheckboxLabel>
        <SCheckbox
          checked={setAsDefault}
          onChange={e => onChange({ ...data, setAsDefault: e.target.checked })}
        />
      </CheckboxRow>
    </Container>
  );
};

export default QuoteDisplay;
